<template>
  <div
    v-if="data.videos.length"
    id="recent"
    class="grid gap-12 w-full lg:grid-cols-3"
  >
    <JournalCard
      v-for="video in data.videos"
      :key="video.videoId"
      :video="video"
    />
  </div>
</template>

<script lang="ts" setup>
const limit = ref(10)
const sort = ref({ date: 1, $numeric: true })
const { data } = await useFetch('/api/videos', {
  method: 'GET',
  query: {
    limit: 3,
  },
})

if (!data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Not Found',
  })
}
</script>

<style scoped>

</style>
